<template>
    <div ref="finderItem"
         :class="[
            'finder-list-item',
            selectedItem ? 'selectedItem': ''
        ]"
         :data-content-id="mediaContent.id"
    >
        <div class="finder-list-item__check">
            <div class="form-checkbox">
                <input :id="`broadcasting_media_contents_${mediaContent.id}`" :checked="selectedItem"
                       type="checkbox"
                       @input="handleSuccessUploadFilterChecked">
                <label :for="`broadcasting_media_contents_${mediaContent.id}`"></label>
            </div>
        </div>
        <div class="finder-list-item__thumbnail">
            <div class="thumbnail-wrapper">
                <div v-if="isTranscodingFail" class="content--tr-fail_dumy-box">
                    <i class="icon icon-info-circle-line dumy-icon"/>
                </div>
                <TranscodingProgressCircle
                    v-if="!isTranscodingFail && !isTranscodingDone"
                    :mediaContent="mediaContent"
                    class="finder"
                />
                <img v-if="!isTranscodingFail" :src="mediaContent.snapshot_url" class="content--info_image">
                <StatusPlay v-if="isTranscodingDone" class="finder" @handlePreview="handlePreview"/>
                <div v-if="isTranscodingDone && fileDuration" class="thumbnail-duration">
                    {{ fileDuration }}
                </div>
            </div>
        </div>
        <div class="finder-list__media-contents">
            <div class="media-contents__name">
                <span>{{ mediaContent.title }}</span>
            </div>
            <div class="media-contents__info">
                <template v-if="isTranscodingFail">
                    <span class="content-info_tr-fail">{{ $t('words.transcoding_fail') }}</span>
                </template>
                <div
                    v-if="!isTranscodingFail && mediaContent.is_passthru"
                    class="content-info_media-block content-info_media-type"
                >
                    <span>PASSTHROUGH</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TranscodingProgressCircle
    from '@/components/cms/common/Content/ContentBodyTable/MediaContentsStatus/TranscodingProgressCircle';
import StatusPlay from '@/components/cms/common/Content/ContentBodyTable/MediaContentsStatus/StatusPlay';
import { mapActions } from 'vuex';


export default {
    name: 'ContentsFinderListItem',

    components: {
        StatusPlay,
        TranscodingProgressCircle,
    },

    props: {
        mediaContent: {
            type: Object,
            default: () => {
            },
        },
        index: {
            type: Number,
            default: 0,
        },
    },

    computed: {
        isTranscodingFail() {
            return this.mediaContent.transcoding_state === 'job assigning error' || this.mediaContent.transcoding_state === 'transcoding error';
        },
        isTranscodingDone() {
            return this.mediaContent.transcoding_state === 'transcoding done';
        },
        fileDuration() {
            return !_.isEmpty(this.mediaContent.duration) ? this.mediaContent.duration : '';
        },
    },

    data() {
        return {
            selectedItem: false,
        };
    },

    methods: {
        ...mapActions({
            fetchPreviewUrl: 'preview/fetchPreviewUrl',
        }),
        handleSuccessUploadFilterChecked() {
            this.selectedItem = !this.selectedItem;
        },
        async handlePreview() {
            const payload = {
                title: this.mediaContent.title,
                mediaContentId: this.mediaContent.id,
                profileKey: this.mediaContent.transcoding_file.profile_key,
            };
            await this.fetchPreviewUrl(payload);

            $('#previewModal').modal({});
        },
    },
};
</script>
